import React, {useState, useEffect} from 'react'
import Tabs from '../../Tabs/Tabs'
import Tab from '../../Tabs/Tab'
import EquipmentResult from './EquipmentResut'
import BuildingResult from './BuildingResult'
import DepartmentResult from './DepartmentResult'
import RoomResult from './RoomResult'
import styled from 'styled-components'
import NoResult from './NoResult'
import {_L, useLocaleState} from '../../../context/LocaleContext'
import Accordion from '../../Accordion/Accordion'
import AccordionPanel from '../../Accordion/AccordionPanel'

/*const BlResultCount = styled.div`
	margin: 0px 20px 0px 20px;
	font-size: 14px;
	display: inline-block;

`
const RmResultCount = styled.div`
margin: 0px 20px 0px 20px;
font-size: 14px;
display: inline-block;

`
const EqResultCount = styled.div`
margin: 0px 20px 0px 20px;
font-size: 14px;
display: inline-block;

`*/

const hasResults = ({/*eq, */bl, rm}) => {
  let result = {

    //hasEq: !!eq.length,
    hasBl: !!bl.length,
    hasRm: !!rm.length
  }

  result.categoriesPopulated = Object.values(result).filter(
    x => x === true
  ).length

  result.hasNone = !(

    //result.hasEq ||
    result.hasBl ||
    result.hasRm
  )

  return result
}

const getActiveIndex = ({/*hasEq,*/ hasBl, hasRm}) => {


  if (hasBl) {
    return 0
  }

  if (hasRm) {
    return 1
  }
/*
  if (hasEq) {
    return 2
  }
*/

  return 0
}

// TODO: investigate better ways to cache the data.
let cachedData = {bl: [], rm: [], /*eq: [],*/ documents: {}}

const SearchResult = ({data, onItemSelect, searchTerm, isSmall, isLoading}) => {
  const localeState = useLocaleState()
  const [activeTab, setActiveTab] = useState(0)
  const [activeIndex, setActiveIndex] = useState([])
  const [blIndex, calcBlIndex] = useState("-1")
  const [rmIndex, calcRmIndex] = useState("-1")
  //const [eqIndex, calcEqIndex] = useState("-1")
  const [blExpanded, calcBlExpanded] = useState("false")
  const [rmExpanded, calcRmExpanded] = useState("false")
  //const [eqExpanded, calcEqExpanded] = useState("false")
  
  let searchData = data || cachedData
  let tabGroup = null
  let activeKeyTab = null
  let arr = null
  let arrIndex = null
  let arrIds = null
  let contentId = null
  const {/*eq,*/ bl, rm, documents} = searchData
  const {

    hasBl,
	hasRm,
    /*hasEq,*/
    hasNone,
    categoriesPopulated
  } = hasResults(searchData)
  
  let expandedArray = ["false","false"/*,"false"*/]
  useEffect(
    () => {
      const activeIndex = getActiveIndex({hasBl, hasRm/*, hasEq*/})
      setActiveTab(activeIndex)
      let indexArray = ["-1","-1"/*,"-1"*/]
      indexArray[activeIndex] = '0'
      calcBlIndex(indexArray[0])
      calcRmIndex(indexArray[1])
      //calcEqIndex(indexArray[2])

      expandedArray[activeIndex] = "true"
      calcBlExpanded(expandedArray[0])
      calcRmExpanded(expandedArray[1])
      //calcEqExpanded(expandedArray[2])
    	  
    },
    [data, hasBl, hasRm/*, hasEq*/]
  )

  // Phone view, open the Accordion Panel if there is only a single result category.
  useEffect(
    () => {
      if (isSmall && categoriesPopulated === 1) {
        setActiveIndex([0])
      }
      
    },
    [categoriesPopulated, isSmall]
  )

  const onActive = index => setActiveTab(index)
  
  
  let blResults = "20+ Results"
  let rmResults = "20+ Results"
  //let eqResults = "20+ Results"	  
  
  if (bl.length ==20){
	blResults = "20+ Results"
  }else{
	blResults = bl.length + " Results"
  }
  if (rm.length == 20){
	rmResults = "20+ Results"
  }else{
	rmResults = rm.length + " Results"
  }
  /*if (eq.length ==20){
	eqResults = "20+ Results"
  }else{
	eqResults = eq.length + " Results"
  }*/


  const onKeyDown = evt => {
	    if (evt) {
	      evt.preventDefault()
	    }
	    activeKeyTab = document.activeElement
	    tabGroup = document.querySelectorAll("div[data-group='tab-group']")
	    arr = Array.prototype.slice.call(tabGroup)
	    arrIndex = arr.indexOf(activeKeyTab)
	    arrIds = arr.map(element => element.id)
	    const origArr = ["building-tab","room-tab"/*,"eq-tab"*/]
	    if(evt.key == "Enter" || evt.key == " " || evt.key == "ArrowDown"){
	    	if(arrIds[arrIndex] != origArr[activeTab]){
	    		expandedArray[activeTab] = "false"
	    		setActiveTab(origArr.indexOf(activeKeyTab.id))
	    		expandedArray[origArr.indexOf(activeKeyTab.id)] = "true"
			    calcBlExpanded(expandedArray[0])
			    calcRmExpanded(expandedArray[1])
			    //calcEqExpanded(expandedArray[2])
	    	} else {
	    	    contentId = arr[arrIndex].getAttribute("aria-owns")
	    		document.getElementById(contentId).firstChild.firstChild.focus()
	    	}
	    	
	    }
	    if(evt.key == "Escape"){ 
	    	document.getElementById("search-input").focus()
	    }
	    if(evt.key == "End"){ 
	    	document.querySelectorAll('[aria-owns$="list"]')[document.querySelectorAll('[aria-owns$="list"]').length - 1].focus()
	    }
	    if(evt.key == "Home"){ 
	    	document.querySelectorAll('[aria-owns$="list"]')[0].focus()
	    }
	    if(evt.key == "ArrowLeft" && (arrIndex + 1) > 1){
	    	tabGroup[arrIndex -1].focus()
	    }
	    if(evt.key == "ArrowRight" && (arrIndex + 1) < arr.length){
	    	tabGroup[arrIndex + 1].focus()
	    }
	    if(evt.key == "Tab"){
	    	document.getElementById("search-input").focus()
	    }
	    
	  }

  const tabletView = () => (
    <>
      {isLoading ? (
        <div />
      ) : (
        <>
          {hasNone ? (
            <NoResult searchTerm={searchTerm} />
          ) : (
            <Tabs onActive={onActive} activeIndex={activeTab}>
              {hasBl && (
                <Tab id="building-tab" 
                	 title={_L({key: 'Buildings', localeState})} 
                	 resultCount={blResults} 
                	 tabIndex={blIndex} 
                	 aria-owns="building-list" 
                	 aria-expanded={blExpanded}
                	 onKeyDown={onKeyDown}
                >
                  <BuildingResult
                    buildings={bl}
                    documents={documents}
                    onItemClick={onItemSelect}
                    onKeyDown={onItemSelect}
                  />
                </Tab>
              )}
              {hasRm && (
                <Tab id="room-tab" 
                	 title={_L({key: 'Rooms', localeState})} 
                	 resultCount={rmResults} 
                	 tabIndex={rmIndex} 
                	 aria-owns="room-list" 
                	 aria-expanded={rmExpanded}
                	 onKeyDown={onKeyDown}
                >
                  <RoomResult rooms={rm} onItemClick={onItemSelect} onKeyDown={onItemSelect}/>
                </Tab>
              )}

            </Tabs>
          )}
        </>
      )}
    </>
  )

  const onAccordionActive = activeIndex => {
    setActiveIndex(activeIndex)
  }

  const phoneView = () => (
    <>
      {isLoading ? (
        <div />
      ) : (
        <div style={{height: '100%', overflowY: scroll}}>
          {hasNone ? (
            <NoResult searchTerm={searchTerm} />
          ) : (
            <Accordion onActive={onAccordionActive} activeIndexes={activeIndex}>
              {hasRm && (
                <AccordionPanel label={_L({key: 'Rooms', localeState})}>
                  <RoomResult
                    rooms={rm}
                    onItemClick={onItemSelect}
                    isSmall={isSmall}
                  />
                </AccordionPanel>
              )}

              {hasBl && (
                <AccordionPanel label={_L({key: 'Buildings', localeState})}>
                  <BuildingResult
                    buildings={bl}
                    documents={documents}
                    onItemClick={onItemSelect}
                    isSmall={isSmall}
                  />
                </AccordionPanel>
              )}

            </Accordion>
          )}
        </div>
      )}
    </>
  )

  return isSmall ? phoneView() : tabletView()
}

export default SearchResult
